import { createColumn, defaultColumns, relationField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Purchase',
    field: 'purchaseId',
    ...relationField({
      validation: { required: true },
      type: 'one',
      localKey: 'purchaseId',
      fk: 'purchaseId',
      namespace: 'purchase',
      filterIs: 'text-filter'
    }),
    component: null
  }),
  createColumn({
    label: 'Contract',
    field: 'contractId',
    ...relationField({
      validation: { required: true },
      type: 'one',
      localKey: 'contractId',
      fk: 'contractId',
      namespace: 'contract',
      filterIs: 'text-filter'
    })
  })
].concat(defaultColumns)
